import { useContext } from 'react';
import { createContext } from 'react';

import { GiftImageProps } from '../@types/GiftImageProps';

export const GiftImageContext = createContext<GiftImageProps>({} as GiftImageProps);

GiftImageContext.displayName = 'GiftImage';

const GiftImageProvider = (props: GiftImageProps) => (
	<GiftImageContext.Provider value={props}>{props.children}</GiftImageContext.Provider>
);

export const useGiftImage = () => {
	const context = useContext(GiftImageContext);

	return context;
};

export default GiftImageProvider;
